// John Eldhose 20201012
import React, { Component } from 'react';
import { setLoginPage } from './lib/LoginPage';
import ReconfigSearch from './lib/ReconfigSearch';

class TeaserReconfig extends Component {

  state = {
    sn: ((window.location.search === '') ? '' : decodeURI(window.location.search.substring(1)).toUpperCase())
  }
  handleSearch = () => {
    setLoginPage({ url: '/reconfig?' + this.state.sn });
    window.location = '/signup';
  }

  render() {
    return (
      <div style={{ paddingTop: '100px' }}>
        <ReconfigSearch
          sn={this.state.sn}
          handleChange={(sn) => this.setState({ sn: sn })}
          handleSearch={this.handleSearch}
        />
      </div>
    );
  }
}

export default TeaserReconfig;



// WEBPACK FOOTER //
// ./src/components/TeaserReconfig.js